import NotificationsModel from "../../../Models/Notifications/Notifications.Model";

export const MAX_TASK_LENGTH = 240;

export function enforceTaskCharLimit(value: string): string {
  if (value.length > MAX_TASK_LENGTH) {
    void NotificationsModel.createToastNotification({
      message: `Task description cannot exceed ${MAX_TASK_LENGTH} characters.`,
      title: "Character limit reached",
      autoDismissMs: 3000
    });
    return value.slice(0, MAX_TASK_LENGTH);
  }
  return value;
}
